import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Menu,
  ListItemText,
} from "@material-ui/core";

import { Edit as EditIcon, Remove as RemoveIcon,  Add as AddIcon} from "@material-ui/icons";

import CustomerLeadCRM from "../../../../components/Tables/CustomerLeadCRM";
import TablePhoneNo from "../../../../components/Tables/TablePhoneNo";
import CallProgressBox from "../../../../components/Boxes/CallProgressBox";
import HeightIcon from '@mui/icons-material/Height';
import Tooltip from "@material-ui/core/Tooltip";
import { ClickAwayListener } from "@material-ui/core";
import GetAppIcon from "@mui/icons-material/GetApp";
import * as XLSX from "xlsx";


//store
import * as actions from "../../../../store/actions/actionIndex";
// uitility function
import { maskedNumber, decryptPhoneNumber} from "../../../../helpers/utility";
import CallerId from "../../../../components/Modal/CallerId";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  columnIcon: {
    backgroundColor: "#0a82da",
    color: "#ffffff",
    padding: "6px",
    fontSize: "32px !important",
    borderRadius: "5px",
    cursor: "pointer",
    margin: "10px",
  
  },
});

function LeadBucket(props) {
  const classes = useStyles();
  const [page, setPage] =  useState(0);
  const [editLead, setEditLead] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
 const [BucketData, setBucketData]  =useState(props.leads)
 const allColumns = props.leads[0] ? Object.keys(props.leads[0]) : [];
const [showColumnDropdown, setShowColumnDropdown] = useState(false);
const [showModal, setShowModal] = useState(false)
const [sendPhone, setSendPhone] = useState("")
const [callerId, setCallerId] = useState("");
const [leadId, setLeadId] = useState("");

const [visibleColumns, setVisibleColumns] = useState(
  allColumns.slice(0, 6) 
);
const COLUMN_STORAGE_KEY = "leadVisibleColumns";


  const [open, setOpen] = useState(
    props.agentState === "CALL_PROGRESS" ? true : false
  );
  const [selectedValue, setSelectedValue] = React.useState(
    props.agentState === "CALL_PROGRESS"
      ? { name: "", phone: props.custPhone ? props.custPhone : "" }
      : {}
  );

  const [expandedLeadId, setExpandedLeadId] = useState(null);


  const openLeadForm = (leadId) => {
    setEditLead(leadId);
    props.onGetCustomerDetails(
      props.agentId,
      props.campaignId,
      leadId,
      "passive"
    );
  };

  const handleClose = React.useCallback(() => {
    setOpen(false);
    setSelectedValue({ name: "", phone: "" });
  }, [setOpen, setSelectedValue]);

  const [anchorEl, setAnchorEl] = useState(null);


  const unSetLead = () => {
    setEditLead(0);
    props.searchAction();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // const notify = (errorMsg) => {
  //   toast.error(errorMsg, {
  //     position: toast.POSITION.BOTTOM_LEFT,
  //     autoClose: 4000,
  //   });
  // };

  const dialHandler = (agentId, phone, leadId, name) => {
    if (props.agentState === "FREE") {
      if(props.campConf.third_party_caller_id === "1" && props.campConf.third_party_caller_id !== null)
        {
          setShowModal(true);
          setSendPhone(decryptPhoneNumber(phone))
          setLeadId(leadId)   
        }
        else{
      props.onAgentDial(agentId, phone, leadId);
      setOpen(true);
      setSelectedValue({ name: name, phone: phone });
        }
    } else {
      alert("Please disconnect the current call first.");
    }
  };

  if (open === true && props.error !== null && !props.loading) {
    // notify("Dial Error - " + props.error);
    setOpen(false);
  }

  useEffect(() => {
    if (props.leads && props.leads.length > 0) {
      const sortedData = [...props.leads].sort((a, b) => {
        const dateA = new Date(a.last_dial_time);
        const dateB = new Date(b.last_dial_time);
        return dateB - dateA;
      });
      setBucketData(sortedData);
  
      const savedColumns = localStorage.getItem(COLUMN_STORAGE_KEY);
      if (savedColumns) {
        try {
          const parsed = JSON.parse(savedColumns);
          if (Array.isArray(parsed)) {
            setVisibleColumns(parsed);
          }
        } catch (e) {
          console.error("Invalid column config in localStorage", e);
        }
      } else {
        const allColumns = Object.keys(props.leads[0] || {});
        setVisibleColumns(allColumns.slice(0, 7));
      }
    }
  }, [props.leads]);
  
// Show Lead Full Data on List view

const showLeadData = (leadId) => {
  if (expandedLeadId === leadId) {
    setExpandedLeadId(null); // collapse if already expanded
  } else {
    setExpandedLeadId(leadId); // expand current lead
  }
};
// Column Toggle
  const handleColumnToggle = (column) => {
    const selected = [...visibleColumns];
    const index = selected.indexOf(column);
    if (index > -1) {
      selected.splice(index, 1);
    } else {
      selected.push(column);
    }
    setVisibleColumns(selected);
    localStorage.setItem(COLUMN_STORAGE_KEY, JSON.stringify(selected));
  };
  
  const handleModalClose = () =>{
    setShowModal(false)
  }
  
   const handleCaller = (selectId) =>{
  const callerIdToUse = selectId || "";
  setCallerId(callerIdToUse)
  props.onAgentDial(props.agentId, sendPhone, leadId, "", callerIdToUse);
   setShowModal(false)
  }


  // Export Data

  const handleExportData = () => {
    if (!BucketData || BucketData.length === 0) return;

    const phoneColumns = [
      "phone1","phone2","phone3","phone4","phone5","phone6","phone7","phone8","phone9"
    ];

    const formatValueForExport = (column, value) => {
      if (!value && value !== 0) return "";
      if (phoneColumns.includes(column)) {
        return decryptPhoneNumber(value);
      }
      return value;
    };

    const dataToExport = BucketData.map((row) => {
      const filteredRow = {};
      visibleColumns.forEach((col) => {
        const header = col
          .replace(/_/g, " ")
          .toLowerCase()
          .replace(/\b\w/g, (c) => c.toUpperCase());

        filteredRow[header] = formatValueForExport(col, row[col]);
      });
      return filteredRow;
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Filtered Data");
  
    // ✅ Generate filename with local date & time
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
    const dateStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
  
    const fileName = `LEAD_Report_${dateStr}.xlsx`;
  
    XLSX.writeFile(wb, fileName);
  };
  return (
    <>
    {showModal && (
<CallerId isOpen = {showModal} onClose={handleModalClose} onCallerIdSelect = {handleCaller} phoneNumber= {sendPhone} />
    )}
  
    <Paper className={classes.root}>
     <div style={{display: "flex", justifyContent: "end"}}>
             {window.Configs.showLeadExport &&
             <Tooltip title="Export Data" arrow>
             <GetAppIcon
               className={classes.columnIcon}
               onClick={handleExportData}
               style={{ marginLeft: "10px", cursor: "pointer"}}
             />
           </Tooltip>
     }

  <ClickAwayListener onClickAway={() => setShowColumnDropdown(false)}>
    <div style={{ position: "relative", display: "inline-block" }}>
      <Tooltip title="Select Columns" arrow>
        <HeightIcon
          className={classes.columnIcon}
          onClick={() => setShowColumnDropdown((prev) => !prev)}
        />
      </Tooltip>

      {showColumnDropdown && (
        <div
          style={{
            position: "absolute",
            top: "40px",
            insetInlineEnd: "0", // align dropdown under icon
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "5px",
            zIndex: 10,
            width: "250px",
            maxHeight: "300px",
            overflowY: "auto",
            padding: "10px",
          }}
        >
          {allColumns.map((column) => {
            if (column === "lead_id") return null;
            return (
              <MenuItem key={column} value={column}>
                <Checkbox
                  checked={visibleColumns.includes(column)}
                  onChange={() => handleColumnToggle(column)}
                  style={{
                    color: visibleColumns.includes(column)
                      ? "#0a82da" 
                      : "#000", 
                  }}
                />
                <ListItemText primary={column.replace(/_/g, " ")} />
              </MenuItem>
            );
          })}
        </div>
      )}
    </div>
  </ClickAwayListener>
</div>



      <TableContainer
        className={classes.leadTable}
        style={{ maxHeight: props.maxHeight, height: props.height }}
      >
        <Table stickyHeader aria-label="sticky table customized table">
          <TableHead>
            <TableRow>
            <TableCell
                key="add"
                style={{
                  whiteSpace: "nowrap",
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "50px",
                }}
              >
                {"  "}
              </TableCell>
              <TableCell
                key="edit"
                style={{
                  whiteSpace: "nowrap",
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "50px",
                }}
              >
                {"Edit"}
              </TableCell>
        
              {visibleColumns.map((column) => (
  <TableCell
    key={column}
    style={{
      whiteSpace: "nowrap",
      fontWeight: "bold",
      textAlign: "center",
    }}
  >
    {column.replace(/_/g, " ").replace(/(^\w{1})|(\s{1}\w{1})/g, (match) =>
      match.toUpperCase()
    )}
  </TableCell>
))}
            </TableRow>
          </TableHead>
         
          <TableBody>
  {BucketData 
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .map((row, key) => {
      return (
        <>
        
        <TableRow hover role="checkbox" tabIndex={-1} key={key}>
          <TableCell
            key="add"
            style={{ whiteSpace: "nowrap", textAlign: "center" }}
          >
            <IconButton
  color="primary"
  component="span"
  title="Show Data"
  onClick={() => showLeadData(row["lead_id"])}
>
  {expandedLeadId === row["lead_id"] ? (
    <RemoveIcon fontSize="small" />
  ) : (
    <AddIcon fontSize="small" />
  )}
</IconButton>

          </TableCell>
          <TableCell
            key="edit"
            style={{ whiteSpace: "nowrap", textAlign: "center" }}
          >
            <IconButton
              color="primary"
              component="span"
              title="Edit"
              onClick={() =>{
                openLeadForm(row["lead_id"], props.campaignId)
              }
            }
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </TableCell>
          {visibleColumns.map((column, index) => {
            const value = row[column];
            if (column === "lead_id") {
              return <TableCell key={index} />;
            }
            return (
              <TableCell
                key={index}
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "center",
                  maxWidth: "300px",
                }}
              >
                {value &&
                  value.trim() !== "" &&
                  (column === "phone1" ||
                    column === "phone2" ||
                    column === "phone3" ||
                    column === "phone4" ||
                    column === "phone5" ||
                    column === "phone6" ||
                    column === "phone7" ||
                    column === "phone8" ||
                    column === "phone9") ? (
                  props.facilityConf.enable_number_mask ? (
                    props.facilityConf.enable_number_mask === "1" ? (
                      <TablePhoneNo
                        phone={maskedNumber(
                          value,
                          props.facilityConf.mask_start_pos,
                          props.facilityConf.mask_end_pos
                        )}
                        dialHandler={() =>
                          dialHandler(
                            props.agentId,
                            value,
                            row["lead_id"],
                            row["name"]
                          )
                        }
                      />
                    ) : (

                      <TablePhoneNo
                        phone={decryptPhoneNumber(
                          value,
                        )}
                        dialHandler={() =>
                          dialHandler(
                            props.agentId,
                            value,
                            row["lead_id"],
                            row["name"]
                          )
                        }
                      />
                  
                    ) 
                  ) : (
                    decryptPhoneNumber(value)
                  )
                ) : (
                  <span
                    style={{
                      whiteSpace: "pre-wrap",
                      overflowWrap: "break-word",
                      maxWidth: "50px",
                    }}
                  >
                    {value}
                  </span>
                )}
              </TableCell>
            );
          })}
        </TableRow>
        {expandedLeadId === row["lead_id"] && (
  <TableRow>
    <TableCell colSpan={visibleColumns.length + 2} style={{ backgroundColor: "#f9f9f9" }}>
      <div style={{ padding: "16px" }}>
        <strong style={{ display: "block", marginBottom: "12px", fontSize: "16px" }}>
         Lead Details
        </strong>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
          }}
        >
          {Object.entries(row).map(([key, val]) => (
            <div
              key={key}
              // style={{
              //   padding: "8px",
              //   background: "#fff",
              //   border: "1px solid #e0e0e0",
              //   borderRadius: "6px",
              // }}
            >
              <strong style={{  fontSize: "16px", color:"#5e5e5e" }}>
                {key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}:
              </strong>
              <div style={{ marginTop: "4px", fontSize: "14px", color: "#444" }}>
                {val ? val : "-"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </TableCell>
  </TableRow>
)}

        </>
      );
    })}
</TableBody>

        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={props.leads.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <CallProgressBox
        selectedValue={selectedValue}
        open={open}
        handleClose={handleClose}
      />
      {editLead && props.leadError === null && !props.leadLoading ? (
        <CustomerLeadCRM
          leadId={editLead}
          unSetLead={unSetLead}
          status={editLead}
        />
      ) : (
        ""
      )}
    </Paper>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    error: state.agentDial.error,
    loading: state.agentDial.loading,
    leadError: state.customerDetails.error,
    leadLoading: state.customerDetails.loading,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    custPhone: state.agentData.custPhone,
    campaignId: state.agentData.campaignId,
    facilityConf: state.agentConfig.facilityConf,
    campConf : state.agentConfig.campConf,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentDial: (agentId, phone, leadId, listId, callerId) =>
      dispatch(actions.agentDial(agentId, phone, leadId,listId, callerId)),
    onGetCustomerDetails: (agentId, campaignId, leadId, leadType) =>
      dispatch(
        actions.getCustomerDetails(agentId, campaignId, leadId, leadType)
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadBucket);
